import React, { useMemo } from "react";
import { StyleSheet, TextStyle } from "react-native";
import { useTheme } from "../hooks/use-theme";
import Text from "../components/Text";

export type ListHeaderProps = {
    value: string;
    style?: TextStyle;
};

const ListHeader: React.FC<ListHeaderProps> = ({ value, style }) => {
    const styles = useStyles();
    return <Text style={[styles.text, style]}>{value}</Text>;
};

const useStyles = () => {
    const { gridSize, fonts, marginSize } = useTheme();
    return useMemo(
        () =>
            StyleSheet.create({
                text: {
                    alignSelf: "stretch",
                    alignContent: "flex-start",
                    flexDirection: "row",
                    paddingLeft: marginSize,
                    paddingRight: marginSize,
                    marginTop: gridSize,
                    ...fonts.titleMedium,
                },
            }),
        [fonts.titleMedium, gridSize, marginSize]
    );
};

export default ListHeader;
